import axios from "axios";

/**
 * Work Instructions API
 *
 * Endpoints from API Guide §8 — Production Instructions
 * Base Path: /v1/production/instruction
 * (axios baseURL is set globally in index.js)
 */

/**
 * Generate a production instruction for a job + stage.
 * POST production/instruction/generate
 *
 * @param {{ job_id: string, stage_code: string }} data
 * @returns Instruction object
 */
export const generateInstruction = async (data) => {
  const response = await axios.post("production/instruction/generate", data);
  return response.data;
};

/**
 * Get instruction by ID.
 * GET production/instruction/:id
 */
export const getInstructionById = async (id) => {
  const response = await axios.get(`production/instruction/${id}`);
  return response.data;
};

/**
 * Get all instructions for a specific job.
 * GET production/instruction/job/:jobId
 *
 * @param {string} jobId
 * @returns Array of instruction objects
 */
export const getInstructionsForJob = async (jobId) => {
  const response = await axios.get(`production/instruction/job/${jobId}`);
  return response.data;
};

/**
 * Get printable instruction data.
 * GET production/instruction/:id/print
 *
 * @returns Instruction data with print_format and generated_at
 */
export const getPrintInstruction = async (id) => {
  const response = await axios.get(`production/instruction/${id}/print`);
  return response.data;
};

/**
 * Complete an instruction — record output, wastage, etc.
 * POST production/instruction/:id/complete
 *
 * @param {string} instructionId
 * @param {{ actual_output, rejected_qty, wastage_qty, notes, attachments? }} data
 */
export const completeInstruction = async (instructionId, data) => {
  const response = await axios.post(
    `production/instruction/${instructionId}/complete`,
    data
  );
  return response.data;
};

/**
 * Update an instruction's content, materials or notes.
 * PUT production/instruction/:id
 *
 * @param {string} instructionId
 * @param {{ content?: object, materials?: array, notes?: string }} data
 */
export const updateInstruction = async (instructionId, data) => {
  const response = await axios.put(
    `production/instruction/${instructionId}`,
    data
  );
  return response.data;
};

const workInstructionsApi = {
  generateInstruction,
  getInstructionById,
  getInstructionsForJob,
  getPrintInstruction,
  completeInstruction,
  updateInstruction,
};

export default workInstructionsApi;
